import {NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';

/** Height in pixels used for virtualized rendering of all plate map note part plugins. */
export const PLATE_MAP_PLUGIN_VIRTUALIZED_HEIGHT = 660;

export type PlateMapKind =
  | NoteLinkedObjectType.NOTE_LINKED_PLATE_DESIGN
  | NoteLinkedObjectType.NOTE_LINKED_PLATE_RECORD
  | NoteLinkedObjectType.NOTE_LINKED_SCRATCH_PLATE
  | NoteLinkedObjectType.NOTE_LINKED_SCRATCH_PLATE_DESIGN;

/**
 * Uses provenanceId rather than provenanceUuid like the rest of the NoteLinkedObjects, since PlateMaps
 * don't have a provenanceUuid defined.
 * @returns Stable identifier or undefined if no provenanceId is given (e.g. upon creation).
 */
export function generatePlateMapCollapseId(
  fileId: string,
  kind: PlateMapKind,
  provenanceId?: number
): string | undefined {
  return provenanceId != null ? `${fileId}::${kind}::${provenanceId}` : undefined;
}
